import React from "react";
import { Typography, Collapse, Divider, Row, Col, Card } from "antd";

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

export const FAQ = () => {
  return (
    <div style={{ padding: "24px" }}>
      <Card>
        <Title level={2}>Veelgestelde Vragen</Title>
        <Paragraph>
          Vind antwoorden op de meest voorkomende vragen over onze freight
          forwarding service.
        </Paragraph>

        <Divider />

        <Row gutter={[24, 24]}>
          <Col xs={24} md={24}>
            <Title level={3}>Boekingen</Title>
            <Collapse accordion>
              <Panel header="Hoe maak ik een nieuwe boeking?" key="1">
                <Paragraph>
                  Om een nieuwe boeking te maken, ga naar de pagina Boekingen en
                  klik op de knop 'Nieuwe Boeking'. Je wordt begeleid door een
                  stapsgewijze boekingswizard die het volgende bevat: 1)
                  Transportgegevens, 2) Leveranciersinformatie, 3)
                  Productgegevens, 4) Basisinformatie over de zending, 5)
                  Afleveringsgegevens, en 6) Beoordeling en indiening.
                </Paragraph>
              </Panel>
              <Panel
                header="Kan ik een boeking bewerken nadat deze is aangemaakt?"
                key="2"
              >
                <Paragraph>
                  Ja, je kunt een boeking bewerken zolang deze nog de status
                  'concept' heeft. Zodra een boeking is ingediend en de status
                  'ingediend', 'goedgekeurd' of een andere verwerkingsstatus
                  heeft, kan deze niet meer worden bewerkt. Als je wijzigingen
                  moet aanbrengen aan een ingediende boeking, neem dan contact
                  op met de klantenservice.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat betekenen de verschillende boekingsstatussen?"
                key="3"
              >
                <Paragraph>
                  Je boekingen kunnen verschillende statussen hebben: 'Concept'
                  betekent dat je boeking wordt opgesteld en nog niet is
                  ingediend. 'Ingediend' betekent dat je boeking ter beoordeling
                  is verzonden. 'Goedgekeurd' betekent dat je boeking is
                  geaccepteerd en wordt verwerkt. 'Afgewezen' betekent dat je
                  boeking is afgewezen (controleer de reden van afwijzing).
                  Andere statussen kunnen verschijnen naarmate je zending
                  vordert in de logistieke keten.
                </Paragraph>
              </Panel>
              <Panel header="Waarom is mijn boeking afgewezen?" key="4">
                <Paragraph>
                  Boekingen kunnen om verschillende redenen worden afgewezen,
                  waaronder onvolledige informatie, problemen met
                  productgegevens, onjuist verzendadres, problemen met naleving
                  van regelgeving, of andere factoren. Wanneer een boeking wordt
                  afgewezen, wordt een reden voor afwijzing gegeven die uitlegt
                  waarom. Je kunt de problemen bekijken en corrigeren, en
                  vervolgens je boeking opnieuw indienen.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe archiveer ik een boeking die ik niet meer nodig heb?"
                key="5"
              >
                <Paragraph>
                  Om een boeking te archiveren, ga naar de pagina Boekingen,
                  zoek de boeking die je wilt archiveren, klik op het
                  archiefpictogram (doos) in de actiekolom. Gearchiveerde
                  boekingen worden verwijderd uit je hoofdboekingenlijst, maar
                  zijn nog steeds toegankelijk vanuit het tabblad 'Gearchiveerd'
                  als je ze later wilt raadplegen.
                </Paragraph>
              </Panel>
              <Panel header="Hoe volg ik mijn boeking?" key="6">
                <Paragraph>
                  Zodra je boeking is goedgekeurd en onderweg is, kun je deze
                  volgen door op de knop 'Volgen' (met een locatiepictogram)
                  naast je boeking in de boekingenlijst te klikken. Dit brengt
                  je naar de pagina Boekingstracker die de huidige status en
                  locatie van je zending weergeeft. Als er een trackingnummer
                  beschikbaar is, kun je dit ook gebruiken om je zending via de
                  website van de vervoerder te volgen.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Producten en Verzendgegevens</Title>
            <Collapse accordion>
              <Panel
                header="Hoe voeg ik producten toe aan mijn boeking?"
                key="7"
              >
                <Paragraph>
                  Tijdens het boekingswizardproces is stap 3 gewijd aan het
                  toevoegen van producten. Je kunt nieuwe producten toevoegen
                  door het productgegevensformulier in te vullen, inclusief
                  naam, HS-code, gewicht, afmetingen en hoeveelheid. Als je
                  eerder producten hebt aangemaakt, kun je deze ook selecteren
                  uit je bestaande productlijst. Meerdere producten kunnen aan
                  één boeking worden toegevoegd.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat is een HS-code en waarom heb ik die nodig?"
                key="8"
              >
                <Paragraph>
                  Een HS-code (Harmonized System) is een internationaal
                  gestandaardiseerde numerieke methode voor het classificeren
                  van handelsproducten. Het is vereist voor douane-inklaring en
                  internationale verzending. De juiste HS-code zorgt voor een
                  correcte beoordeling van rechten en belastingen, en helpt
                  vertragingen bij de douane te voorkomen. Als je niet zeker
                  bent van de juiste HS-code voor je product, kun je een
                  douane-expediteur raadplegen of online HS-code zoektools
                  gebruiken.
                </Paragraph>
              </Panel>
              <Panel header="Hoe bereken ik brutogewicht en CBM?" key="9">
                <Paragraph>
                  Brutogewicht is het totale gewicht van je product inclusief
                  verpakking. Het moet worden gemeten in kilogrammen. CBM (Cubic
                  Meters) is de volumeberekening van je zending. Om CBM te
                  berekenen, vermenigvuldig je de lengte, breedte en hoogte in
                  meters. Als je doos bijvoorbeeld 0,5 m × 0,4 m × 0,3 m is, zou
                  de CBM 0,06 kubieke meter zijn. Nauwkeurige metingen zijn
                  cruciaal voor correcte vrachtprijzen en planning.
                </Paragraph>
              </Panel>
              <Panel
                header="Is EAN-nummer vereist voor verzendlabels?"
                key="10"
              >
                <Paragraph>
                  Hoewel het niet altijd verplicht is, wordt het verstrekken van
                  een EAN (International Article Number) voor je producten sterk
                  aanbevolen omdat het helpt bij tracking, voorraadbeheer en
                  douane-inklaring. Wanneer je een EAN verstrekt, genereert ons
                  systeem automatisch een barcode op je verzendlabels, waardoor
                  de verwerking in de hele toeleveringsketen efficiënter wordt.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe voeg ik meerdere producten toe aan dezelfde boeking?"
                key="28"
              >
                <Paragraph>
                  Tijdens het maken van een boeking kun je meerdere producten
                  aan dezelfde zending toevoegen. Ga in de boekingswizard naar
                  de stap 'Productgegevens' en klik op de knop 'Product
                  toevoegen' na het invullen van de gegevens van je eerste
                  product. Je kunt ook bestaande producten selecteren uit je
                  productlijst. Alle producten worden onder dezelfde boeking
                  verzonden, maar elk product krijgt zijn eigen verzendlabel.
                </Paragraph>
              </Panel>
              <Panel
                header="Kan ik mijn producten importeren vanuit een spreadsheet?"
                key="29"
              >
                <Paragraph>
                  Ja, je kunt je producten in bulk importeren via een
                  CSV-bestand. Ga naar de pagina 'Mijn Producten', klik op
                  'Producten importeren' en volg de instructies. Je kunt eerst
                  een sjabloon downloaden om de juiste formattering te zien. Dit
                  kan je veel tijd besparen als je veel producten hebt die je
                  wilt toevoegen aan het systeem.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Verzendlabels en Documentatie</Title>
            <Collapse accordion>
              <Panel header="Hoe genereer ik verzendlabels?" key="11">
                <Paragraph>
                  Verzendlabels worden automatisch gegenereerd zodra je boeking
                  is goedgekeurd. Je kunt ze downloaden vanaf de pagina met
                  boekingsgegevens. Voor elk product in je boeking wordt een
                  apart verzendlabel gegenereerd. Deze labels moeten worden
                  afgedrukt en op elke doos van je zending worden geplakt.
                </Paragraph>
              </Panel>

              <Panel
                header="Welke documenten heb ik nodig voor douane-inklaring?"
                key="14"
              >
                <Paragraph>
                  Voor internationale zendingen heb je meestal het volgende
                  nodig: 1) commercial invoice: Bevat details over de verkoper,
                  koper en producten, inclusief waarden; 2) Verzendlabels:
                  Gegenereerd door ons systeem; 3) Certificaat van Oorsprong
                  (indien vereist): Bewijst waar producten zijn vervaardigd.
                  Andere documenten kunnen vereist zijn, afhankelijk van de
                  producten en de betrokken landen. Ons systeem zal je door de
                  vereiste documentatie leiden tijdens het boekingsproces.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat is een commercial invoice en hoe voeg ik deze toe aan mijn boeking?"
                key="30"
              >
                <Paragraph>
                  Een commercial invoice is een belangrijk document voor
                  internationale zendingen dat de details van de transactie
                  bevat, inclusief de verkoper, koper, productomschrijving,
                  hoeveelheden, waarden en oorsprong. Tijdens het boekingsproces
                  kun je een commercial invoice uploaden in het gedeelte
                  'Basisgegevens'. Zorg ervoor dat je commercial invoice
                  nauwkeurig is ingevuld, omdat douaneautoriteiten dit document
                  gebruiken om invoerrechten en belastingen te bepalen.
                </Paragraph>
              </Panel>
              <Panel
                header="Moet ik mijn verzendlabels op een speciale manier bevestigen?"
                key="31"
              >
                <Paragraph>
                  Verzendlabels moeten duidelijk zichtbaar op de buitenkant van
                  elke doos worden aangebracht. Zorg ervoor dat het label
                  volledig leesbaar is en niet over randen of naden wordt
                  geplakt. We raden aan om labels in een transparante envelop te
                  plaatsen of te lamineren als er risico is op blootstelling aan
                  water of beschadiging. Als je meerdere dozen verzendt, zorg er
                  dan voor dat elk label op de juiste doos wordt aangebracht
                  volgens de informatie op het label.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Transport en Levering</Title>
            <Collapse accordion>
              <Panel header="Welke transporttypes zijn beschikbaar?" key="15">
                <Paragraph>
                  Ons platform ondersteunt verschillende transporttypes,
                  waaronder Zeevracht (FCL en LCL), Luchtvracht, en mogelijk
                  andere opties, afhankelijk van je herkomst en bestemming. Elk
                  transporttype heeft verschillende transittijden, kosten en
                  capaciteitsbeperkingen. Tijdens het boekingsproces kun je het
                  transporttype selecteren dat het beste bij je
                  zendingsbehoeften past.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat zijn Incoterms en welke moet ik kiezen?"
                key="16"
              >
                <Paragraph>
                  Incoterms (International Commercial Terms) zijn
                  gestandaardiseerde handelsvoorwaarden die de
                  verantwoordelijkheden van kopers en verkopers in
                  internationale transacties definiëren. Veelvoorkomende
                  Incoterms zijn EXW (Ex Works), FOB (Free on Board) en FCA
                  (Free Carrier). Elke term specificeert wie verantwoordelijk is
                  voor de kosten van verzending, verzekering en
                  douane-inklaring. De juiste Incoterm hangt af van je
                  specifieke regeling met je leverancier of klant.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe lang duurt het voordat mijn zending aankomt?"
                key="17"
              >
                <Paragraph>
                  Transittijden variëren afhankelijk van het transporttype,
                  herkomst en bestemming. Luchtvracht duurt meestal 1-7 dagen,
                  zeevracht kan 15-60 dagen duren, en andere factoren zoals
                  douane-inklaring kunnen extra tijd toevoegen. Zodra je boeking
                  is verwerkt, ontvang je een geschatte leverdatum. Je kunt de
                  voortgang van je zending volgen via onze
                  boekingstrackerfunctie.
                </Paragraph>
              </Panel>
              <Panel
                header="Kan ik ophalen bij mijn leverancier regelen?"
                key="18"
              >
                <Paragraph>
                  Ja, tijdens het boekingsproces kun je leveranciersgegevens
                  verstrekken en ophaaldiensten aanvragen. Deze optie is
                  beschikbaar in de stappen voor transport- en
                  leveranciersgegevens van de boekingswizard. Er kunnen extra
                  kosten in rekening worden gebracht voor ophaaldiensten, en de
                  beschikbaarheid is afhankelijk van de locatie van je
                  leverancier.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat is het verschil tussen FCL en LCL zeevracht?"
                key="36"
              >
                <Paragraph>
                  FCL (Full Container Load) betekent dat je een volledige
                  container huurt voor je zending, ongeacht of je deze volledig
                  vult. Dit is ideaal voor grotere volumes of als je wilt dat je
                  goederen niet worden gemengd met die van anderen. LCL (Less
                  than Container Load) betekent dat je goederen een container
                  delen met zendingen van andere klanten. LCL is
                  kosteneffectiever voor kleinere volumes, maar heeft meestal
                  langere doorlooptijden door de extra consolidatie- en
                  deconsolidatiestappen.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe beïnvloedt seizoensgebondenheid mijn verzending?"
                key="37"
              >
                <Paragraph>
                  Transportkosten en beschikbaarheid kunnen aanzienlijk variëren
                  afhankelijk van het seizoen. Piekperiodes zoals de aanloop
                  naar feestdagen (vooral Q4) zien vaak verhoogde tarieven en
                  beperkte capaciteit voor zowel lucht- als zeevracht. Chinese
                  Nieuwjaar veroorzaakt ook aanzienlijke vertragingen vanuit
                  Azië. We raden aan om boekingen ruim van tevoren te maken
                  tijdens deze periodes en je te abonneren op onze updates om op
                  de hoogte te blijven van marktomstandigheden.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe worden gevaarlijke goederen afgehandeld?"
                key="38"
              >
                <Paragraph>
                  Gevaarlijke goederen (Dangerous Goods of DG) vereisen speciale
                  afhandeling en documentatie. Als je DG wilt verzenden, moet je
                  dit duidelijk aangeven tijdens het boekingsproces en de juiste
                  classificatie en VN-nummer verstrekken. Aanvullende kosten
                  zijn van toepassing en niet alle vervoerders accepteren alle
                  klassen van gevaarlijke goederen. Neem contact op met ons
                  supportteam voor advies voordat je gevaarlijke goederen boekt.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Douane</Title>
            <Collapse accordion>
              <Panel
                header="Wat gebeurt er als mijn zending wordt vastgehouden door de douane?"
                key="39"
              >
                <Paragraph>
                  Als je zending wordt vastgehouden door de douane, zullen we je
                  zo snel mogelijk informeren en samenwerken om het probleem op
                  te lossen. Veelvoorkomende redenen zijn onvolledige of
                  onjuiste documentatie, vereiste vergunningen of inspecties. In
                  de meeste gevallen is aanvullende informatie of documentatie
                  nodig om de vrijgave te verkrijgen. Extra kosten zoals
                  opslagkosten of inspectievergoedingen kunnen worden toegepast
                  en zijn voor rekening van de klant.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe kan ik importheffingen en -belastingen berekenen?"
                key="41"
              >
                <Paragraph>
                  Importheffingen en -belastingen variëren per land en
                  producttype. Ze worden berekend op basis van de waarde van je
                  goederen, het land van oorsprong, HS-code en soms andere
                  factoren. De exacte bedragen zijn pas bekend wanneer de
                  zending door de douane wordt afgehandeld. We raden aan om
                  vooraf de douanetarieven van het bestemmingsland te
                  controleren of een douane-expert te raadplegen voor
                  nauwkeurige berekeningen.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Account en Bedrijfsinformatie</Title>
            <Collapse accordion>
              <Panel
                header="Waarom heb ik bedrijfsgoedkeuring nodig voordat ik boekingen maak?"
                key="19"
              >
                <Paragraph>
                  Bedrijfsgoedkeuring is vereist om je bedrijfsinformatie te
                  verifiëren en naleving van verzendvoorschriften te garanderen.
                  Dit omvat het verifiëren van je bedrijfsregistratie, adres en
                  contactgegevens. Zodra je bedrijf is goedgekeurd, kun je
                  beginnen met het maken van boekingen. Het goedkeuringsproces
                  duurt meestal 1-2 werkdagen.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat zijn de verschillende statussen van bedrijfsgoedkeuring?"
                key="20"
              >
                <Paragraph>
                  Je bedrijf kan verschillende statussen hebben: 'Niet
                  goedgekeurd' betekent dat je bedrijfsinformatie moet worden
                  ingevuld en ingediend voor beoordeling. 'In beoordeling'
                  betekent dat je informatie wordt geverifieerd. 'Goedgekeurd'
                  betekent dat je bedrijf is geverifieerd en je boekingen kunt
                  maken. Als je bedrijf wordt afgewezen, word je op de hoogte
                  gesteld van de reden en kun je je informatie bijwerken voor
                  heroverweging.
                </Paragraph>
              </Panel>
              <Panel
                header="Kan ik meerdere gebruikers voor mijn bedrijfsaccount hebben?"
                key="21"
              >
                <Paragraph>
                  Momenteel ondersteunt ons systeem één primair
                  gebruikersaccount per bedrijf. Als je wilt dat meerdere
                  teamleden toegang hebben tot het platform, kunnen wij deze
                  teamleden toevoegen.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe kan ik mijn accountgegevens bijwerken?"
                key="43"
              >
                <Paragraph>
                  Je kunt je accountgegevens bijwerken door naar de pagina
                  'Account' te gaan via het menu. Hier kun je je persoonlijke
                  informatie, e-mailadres en wachtwoord wijzigen. Voor
                  wijzigingen in bedrijfsinformatie ga je naar de pagina
                  'Bedrijfsinfo'. Let op: wijzigingen in je bedrijfsinformatie
                  kunnen opnieuw een goedkeuringsproces vereisen, vooral bij
                  significante veranderingen zoals een nieuw adres of
                  bedrijfsnaam.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat moet ik doen als ik mijn wachtwoord ben vergeten?"
                key="44"
              >
                <Paragraph>
                  Als je je wachtwoord bent vergeten, klik dan op de link
                  'Wachtwoord vergeten?' op de inlogpagina. Voer je e-mailadres
                  in en je ontvangt een e-mail met instructies om je wachtwoord
                  opnieuw in te stellen. Als je geen e-mail ontvangt, controleer
                  dan je spam/junk-map of neem contact op met onze
                  klantenservice voor hulp.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Prijzen en Betaling</Title>
            <Collapse accordion>
              <Panel
                header="Hoe kan ik de geschatte kosten van mijn zending zien?"
                key="22"
              >
                <Paragraph>
                  Na het invoeren van je zendingsgegevens in de boekingswizard,
                  kun je contact opnemen met onze klantenservice voor een
                  kostenraming. Zorg ervoor dat je alle details zoals
                  transporttype, herkomst, bestemming, gewicht en volume
                  beschikbaar hebt voor een nauwkeurige schatting. Definitieve
                  kosten worden bevestigd na verificatie van alle
                  zendingsgegevens.
                </Paragraph>
              </Panel>
              <Panel
                header="Welke factoren beïnvloeden de kosten van verzending?"
                key="23"
              >
                <Paragraph>
                  Meerdere factoren bepalen de verzendkosten: 1) Transporttype
                  (lucht, zee, enz.); 2) Herkomst en bestemming; 3) Gewicht en
                  volume (dimensionaal gewicht); 4) Geselecteerde Incoterms; 5)
                  Aanvullende diensten (verzekering, speciale behandeling); 6)
                  Huidige brandstoftoeslagen; 7) Seizoensgebonden factoren en
                  capaciteitsbeperkingen. Voor een nauwkeurige prijsopgave kun
                  je contact opnemen met onze klantenservice.
                </Paragraph>
              </Panel>
              <Panel
                header="Wanneer en hoe betaal ik voor mijn zending?"
                key="24"
              >
                <Paragraph>
                  Na goedkeuring van je boeking ontvang je een gedetailleerde
                  factuur met alle kosten. Onze standaard betalingstermijn is 14
                  dagen na factuurdatum, tenzij anders overeengekomen. We
                  accepteren betalingen via bankoverschrijving naar het
                  rekeningnummer vermeld op de factuur. Zorg ervoor dat je het
                  factuurnummer vermeldt bij je betaling. Voor vragen over
                  betalingen kun je contact opnemen met onze financiële afdeling
                  via finance@efreightforwarding.com.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat zijn de kosten voor aanvullende diensten?"
                key="45"
              >
                <Paragraph>
                  Aanvullende diensten zoals verzekering, priority handling,
                  verpakkingsdiensten of speciale douaneafhandeling hebben extra
                  kosten. Voor een gedetailleerd overzicht van deze kosten kun
                  je contact opnemen met onze klantenservice tijdens het plannen
                  van je zending. Voor sommige diensten zoals douane-inspecties
                  of onvoorziene opslag kunnen kosten achteraf worden
                  toegevoegd. We streven ernaar om alle kosten zo transparant
                  mogelijk te maken en je vooraf te informeren.
                </Paragraph>
              </Panel>
              <Panel header="Bieden jullie volumekortingen aan?" key="46">
                <Paragraph>
                  Ja, we bieden volumekortingen voor klanten met regelmatige
                  verzendbehoeften of grote volumes. De kortingen worden
                  berekend op basis van je verzendfrequentie, volume en
                  bestemmingen. Neem contact op met ons verkoopteam om je
                  specifieke behoeften te bespreken en een aangepaste
                  prijsopgave te ontvangen. We kunnen ook speciale
                  tariefafspraken maken voor bepaalde routes of seizoenen op
                  basis van je verwachte verzendvolume.
                </Paragraph>
              </Panel>
            </Collapse>

            <Divider />

            <Title level={3}>Ondersteuning en Probleemoplossing</Title>
            <Collapse accordion>
              <Panel
                header="Hoe kan ik contact opnemen met klantenservice?"
                key="25"
              >
                <Paragraph>
                  Je kunt ons klantenserviceteam bereiken via e-mail op
                  info@efreightforwarding.com of telefonisch op +31 (0)85 0607
                  063. Onze klantenserviceuren zijn maandag tot vrijdag, 9:00
                  tot 17:00 uur Midden-Europese tijd. Voor dringende zaken
                  buiten kantooruren, stuur ons een e-mail met 'URGENT' in de
                  onderwerpregel.
                </Paragraph>
              </Panel>
              <Panel
                header="Ik heb technische problemen met het platform. Wat moet ik doen?"
                key="26"
              >
                <Paragraph>
                  Als je technische problemen ondervindt, probeer dan eerst de
                  pagina te vernieuwen of je browsercache te wissen. Zorg ervoor
                  dat je een ondersteunde browser gebruikt (Chrome, Firefox,
                  Safari of Edge). Als de problemen aanhouden, neem dan contact
                  op met ons technische ondersteuningsteam met details over het
                  probleem, inclusief eventuele foutmeldingen, het apparaat en
                  de browser die je gebruikt, en stappen om het probleem te
                  reproduceren.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe kan ik feedback geven over de service?"
                key="27"
              >
                <Paragraph>
                  We waarderen je feedback! Je kunt je suggesties, opmerkingen
                  of zorgen sturen naar feedback@efreightforwarding.com. We
                  bekijken regelmatig klantenfeedback om onze diensten en
                  platformfunctionaliteit te verbeteren. Als je specifieke
                  functieverzoeken hebt, voeg dan zoveel mogelijk details toe om
                  ons te helpen je behoeften te begrijpen.
                </Paragraph>
              </Panel>
              <Panel
                header="Wat moet ik doen bij vertraging of vermiste zending?"
                key="47"
              >
                <Paragraph>
                  Als je zending vertraging oploopt of vermist is, neem dan
                  onmiddellijk contact op met onze klantenservice. Zorg ervoor
                  dat je je boekingsreferentie bij de hand hebt. Voor
                  vertragingen monitoren we de situatie en houden je op de
                  hoogte van de voortgang. Voor vermiste zendingen starten we
                  een onderzoeksprocedure en werken samen met vervoerders en
                  douane om je zending te lokaliseren. In geval van schade of
                  verlies kan verzekeringsdekking van toepassing zijn indien
                  deze was afgesloten bij de boeking.
                </Paragraph>
              </Panel>
              <Panel
                header="Hoe kan ik mijn zakelijke verzendprocessen stroomlijnen?"
                key="48"
              >
                <Paragraph>
                  Voor regelmatige verzenders bieden we verschillende opties om
                  je verzendprocessen te stroomlijnen. Je kunt veelgebruikte
                  producten opslaan voor snel hergebruik, verzendsjablonen maken
                  voor terugkerende routes, en bulk-importen van productgegevens
                  uitvoeren. We kunnen ook aangepaste integraties met je ERP- of
                  e-commercesysteem bespreken voor automatische
                  gegevensoverdracht. Neem contact op met ons verkoopteam om te
                  bespreken hoe we je specifieke workflows kunnen optimaliseren.
                </Paragraph>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default FAQ;
